import { render, staticRenderFns } from "./DefaultDetail.vue?vue&type=template&id=73f6ab18"
import script from "./DefaultDetail.vue?vue&type=script&lang=js"
export * from "./DefaultDetail.vue?vue&type=script&lang=js"
import style0 from "./DefaultDetail.vue?vue&type=style&index=0&id=73f6ab18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports